



































import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Rules extends Vue {
  imgList: any = [
    {
      url: require('../assets/prize1.jpg'),
      text: '“甜甜虎”玩偶一个（款式随机）：',
    },
    {
      url: require('../assets/prize2.jpg'),
      text: '“甜甜虎”保温杯：',
    },
    {
      url: require('../assets/prize8.jpg'),
      text: '“甜甜虎”对联：',
    },
    {
      url: require('../assets/prize4.jpg'),
      text: '“甜甜虎”中国结：',
    },
    {
      url: require('../assets/prize6.jpg'),
      text: '“甜甜虎”直尺套装：',
    },
    {
      url: require('../assets/prize3.jpg'),
      text: '“甜甜虎”纸巾（抽纸一盒或者手帕纸一条）',
    },
  ];
  close() {
    this.$emit('ruleClose');
  }
}
